import { email, required } from 'vuelidate/lib/validators'
import { passesApiValidation } from '@/plugins/vuelidate/validators'

export const validations = {
    email: {
        required,
        email,
        passesApiValidation: passesApiValidation('email')
    },
    password: {
        required,
        passesApiValidation: passesApiValidation('password')
    },
}

export const messages = {
    email: {
        required: 'Required',
        email: 'Must be a valid email address',
    },
    password: {
        required: 'Required',
    },
    forgotPassword: {
        email: {
            required: 'Required',
            email: 'Must be a valid email address',
        }
    }
}
